import { IMicrofrontendManifest } from '@cian/mf-registry/shared';

import { DESKTOP_FILTERS_MICROFRONTEND_MANIFEST } from '../../constants/microfrontends';
import { useApplicationContext } from '../../containers/ApplicationContext';

export function useIsDesktopFiltersMicrofrontendEnabled(): boolean {
  const { config } = useApplicationContext();

  const isRsEnabled = config.get<boolean>('Dailyrent.DesktopFiltersMicrofrontend.Enabled') ?? false;
  const manifest = config.get<IMicrofrontendManifest | null>(DESKTOP_FILTERS_MICROFRONTEND_MANIFEST);

  return isRsEnabled && manifest !== null && manifest !== undefined;
}
